import { render, staticRenderFns } from "./MypageInventoryDetails.vue?vue&type=template&id=5ca6a3fe&scoped=true&"
import script from "./MypageInventoryDetails.vue?vue&type=script&lang=js&"
export * from "./MypageInventoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./MypageInventoryDetails.vue?vue&type=style&index=0&id=5ca6a3fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca6a3fe",
  null
  
)

export default component.exports